import React, { useState, useEffect } from "react";
import "./Projects.css";
import ProjectCard from "./ProjectCard";
import ProjectModal from "./ProjectModal";

const projects = [
  {
    id: 1,
    title: "Analytics",
    description:
      "No vanity metrics. One number that matters right now: total visits to your site.",
    tools: "React, TypeScript, Vercel",
    imageUrl: "assets/projects/analytics/icon.webp",
    slides: ["assets/projects/analytics/icon.webp"],
    repoAvailability: false,
    deployed: true,
    projectUrl: "https://analytics.leocode.tech",
    repoUrl: "https://github.com/leocodeio/analytics",
  },
  {
    id: 2,
    title: "Spectral",
    description:
      "Monorepo for SPECTRAL, A social media creator firiendly application that helps creators and editors to manage their content and communicate, upload to YouTube efficiently",
    tools: "React, TypeScript, Vercel",
    imageUrl: "assets/projects/spectral/icon.webp",
    slides: ["assets/projects/spectral/icon.webp"],
    repoAvailability: false,
    deployed: true,
    projectUrl: "https://spectral.leocode.tech",
    repoUrl: "https://github.com/leocodeio/spectral",
  },
  {
    id: 3,
    title: "AnimeSpam",
    description:
      "A service website for the anime editing community, allowing users to download available 4k upscaled twixtors.",
    tools: "React, TypeScript, Vercel",
    imageUrl: "assets/projects/animespam/icon.webp",
    slides: ["assets/projects/animespam/icon.webp"],
    repoAvailability: false,
    deployed: true,
    projectUrl: "https://animespam.vercel.app/",
    repoUrl: "https://github.com/leocodeio/animespam",
  },
  {
    id: 4,
    title: "Chatpilot",
    description:
      "ChatPilot is a web-based chatbot powered by machine learning and web scraping, designed to provide intelligent replies based on scraped website data.",
    tools: "React, TypeScript, Vercel",
    imageUrl: "assets/projects/chatpilot/icon.webp",
    slides: [
      "assets/projects/chatpilot/icon.webp",
      "assets/projects/chatpilot/cp_1.webp",
      "assets/projects/chatpilot/cp_2.webp",
      "assets/projects/chatpilot/cp_3.webp",
      "assets/projects/chatpilot/cp_4.webp",
      "assets/projects/chatpilot/cp_5.webp",
      "assets/projects/chatpilot/cp_6.webp",
      "assets/projects/chatpilot/cp_7.webp",
      "assets/projects/chatpilot/cp_8.webp",
      "assets/projects/chatpilot/cp_9.webp",
      "assets/projects/chatpilot/cp_10.webp",
    ],
    repoAvailability: false,
    deployed: false,
    projectUrl: "https://chatpilot.leocode.tech",
    repoUrl: "https://github.com/leocodeio/chatpilot",
  },
  {
    id: 5,
    title: "Catalyst",
    description:
      "Building Catalyst, a community platform designed to unite industrious individuals, offer cutting-edge technologies and services, and foster collaborative opportunities for emerging talent.",
    tools: "Remix, Postgresql, Prisma, Vercel",
    imageUrl: "assets/projects/community/icon.webp",
    slides: ["assets/projects/community/icon.webp"],
    repoAvailability: true,
    deployed: true,
    projectUrl: "https://catalyst-com.vercel.app/",
    repoUrl: "https://github.com/leocodeio/catalyst-com",
  },
  {
    id: 6,
    title: "Gitsprint",
    description:
      "Minum clicks. Easy to manage dashboard. Team management. Ticket management. Time board. Github sync. Gitsprint brings all of this together to bring your sprint to work better.",
    tools: "Remix, Postgresql, Prisma, Vercel",
    imageUrl: "assets/projects/gitsprint/icon.webp",
    slides: ["assets/projects/gitsprint/icon.webp"],
    repoAvailability: true,
    deployed: true,
    projectUrl: "https://gitsprint.com",
    repoUrl: "https://github.com/leocodeio/gitsprint-opensource",
  },
  {
    id: 7,
    title: "Domain-In-Domain",
    description:
      "A user-friendly interface that stores pairs of URL and domain name, allowing domain names to be used for rendering or redirecting to the specified URLs.",
    tools: "Node, React, PostgreSQL, Express, Render, Vercel",
    imageUrl: "assets/projects/did/icon.webp",
    slides: [
      "assets/projects/did/icon.webp",
      "assets/projects/did/did_1.webp",
      "assets/projects/did/did_2.webp",
      "assets/projects/did/did_3.webp",
      "assets/projects/did/did_4.webp",
      "assets/projects/did/did_5.webp",
      "assets/projects/did/did_6.webp",
      "assets/projects/did/did_7.webp",
    ],
    repoAvailability: true,
    deployed: true,
    projectUrl: "https://did.leocode.tech",
    repoUrl: "https://github.com/leocodeio/catalyst-domain-in-domain",
  },
  {
    id: 8,
    title: "Cropto",
    description:
      "Cropto is a full-stack machine learning-based web application designed to predict crop success based on dependent factors.",
    tools: "Remix, python, Hugging face, Vercel",
    imageUrl: "assets/projects/cropto/icon.webp",
    slides: ["assets/projects/cropto/icon.webp"],
    repoAvailability: true,
    deployed: true,
    projectUrl: "https://cropto.leocode.tech",
    repoUrl: "https://github.com/leocodeio/cropto",
  },
  {
    id: 9,
    title: "Tic-Tac-Toe",
    description:
      "A fully functional multiplayer Tic-Tac-Toe game with efficient user management and real-time gameplay.",
    tools: "Node, React, MongoDB, Express, Socket-io, Atlas, Glitch",
    imageUrl: "assets/projects/ttt/icon.webp",
    slides: ["assets/projects/ttt/icon.webp", "assets/projects/ttt/ttt_1.png"],
    repoAvailability: true,
    deployed: true,
    projectUrl: "https://ttt.leocode.tech",
    repoUrl: "https://github.com/leocodeio/tic-tac-toe",
  },
  {
    id: 10,
    title: "StarClassifier",
    description:
      "An image classification model integrated with a frontend UI, offering a user-friendly and responsive experience.",
    tools:
      "Python, Django, HTML, CSS, JS, CNN (Neural Networks), Wavelet transforms",
    imageUrl: "assets/projects/starclassifier/icon.webp",
    slides: [
      "assets/projects/starclassifier/icon.webp",
      "assets/projects/starclassifier/sc_1.png",
    ],
    repoAvailability: true,
    deployed: true,
    projectUrl: "https://starclassifier.leocode.tech",
    repoUrl: "https://github.com/leocodeio/starclassifier",
  },
];

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.startsWith("#project-")) {
      const id = parseInt(hash.replace("#project-", ""), 10);
      const found = projects.find((p) => p.id === id);
      if (found) setSelectedProject(found);
    }
  }, []);

  const openModal = (project) => {
    setSelectedProject(project);
    window.history.pushState(null, "", `#project-${project.id}`);
  };

  const closeModal = () => {
    setSelectedProject(null);
    window.history.replaceState(null, "", window.location.pathname);
  };

  useEffect(() => {
    const onHashChange = () => {
      const hash = window.location.hash;
      if (!hash.startsWith("#project-")) {
        setSelectedProject(null);
        return;
      }
      const id = parseInt(hash.replace("#project-", ""), 10);
      const found = projects.find((p) => p.id === id);
      setSelectedProject(found || null);
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return (
    <>
      <section className="projects-section">
        <h2 className="section-title">Projects</h2>
        <div className="projects-container">
          {projects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              onOpen={openModal}
            />
          ))}
        </div>
      </section>
      {selectedProject && (
        <ProjectModal project={selectedProject} onClose={closeModal} />
      )}
    </>
  );
};

export default Projects;
